import React from "react";

export default function Error(){
    return(
        <h2>Error 404....file not found</h2>
    )
}